import { CustomDatePipe } from '@abovo/shared-angular-utils';
import { MediaPlanFlight } from '@abovo/shared-models';

import { ChangeDetectionStrategy, Component, computed, effect, input, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatChip, MatChipSet } from '@angular/material/chips';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
   selector: 'webvis-feature-manage-flights',
   imports: [MatChipSet, MatChip, TranslatePipe, FaIconComponent, MatMenuTrigger, MatMenu, MatMenuItem, MatCheckbox, FormsModule, CustomDatePipe],
   templateUrl: './manage-flights.component.html',
   styleUrl: './manage-flights.component.scss',
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageFlightsComponent {
   flights = input<(MediaPlanFlight & { hidden?: boolean })[]>([]);

   private selectedFlights = signal<MediaPlanFlight[]>(this.flights());
   selectedFlightIds = computed(() => this.selectedFlights().map((f) => f.id));

   caretDown = faCaretDown;

   flightsInputEffect = effect(
      () => {
         this.selectedFlights.set(this.flights());
      },
      { allowSignalWrites: true },
   );

   toggleFlight(flight: MediaPlanFlight, evt: MouseEvent) {
      evt.stopPropagation();

      this.selectedFlights.update((selectedFlights) => {
         if (selectedFlights.find((sf) => sf.id === flight.id)) {
            return selectedFlights.filter((sf) => sf.id !== flight.id);
         } else {
            return [...selectedFlights, flight];
         }
      });
   }
}
